// extracted by css-extract-rspack-plugin
export default {"Text":"single-select-editor-module__Text__jHL02ow"};